export const ACTIVE_TRIP_STORAGE_KEY = 'pazportal.onsite.activeTripId';

export function hrefWithTrip(href: string, tripId: string | null | undefined): string {
  if (!tripId) return href;
  const [pathAndQuery, hash] = href.split('#');
  const url = new URL(pathAndQuery, 'http://onsite.local');
  url.searchParams.set('trip', tripId);
  const search = url.searchParams.toString();
  return `${url.pathname}${search ? `?${search}` : ''}${hash ? `#${hash}` : ''}`;
}

export function readStoredTripId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return sessionStorage.getItem(ACTIVE_TRIP_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function storeTripId(id: string): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(ACTIVE_TRIP_STORAGE_KEY, id);
  } catch {
    // ignore quota / private-mode failures
  }
}
